import BenchlingConfig from 'BenchlingConfig';
import {getQueryParam} from 'BenchlingUtil';
import * as NavConstants from 'constants/NavConstants';
import {_editorBase} from 'foundation/EditorRoutes';
import {NewChatRequest} from 'llm/chat-library/sidepanel/ChatRouter';
import {openChat, openNewChat} from 'llm/chat-library/sidepanel/ChatRouterUtil';
import {ChatTypeByAgentType, getAgentTypeFromQueryStringValue} from 'llm/chat-library/sidepanel/ChatTypeUtil';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import DatadogUtil from 'performance/DatadogUtil';
import {RouteBundle} from 'routing/RouteConstants';

function getChatTypeFromQueryParam(): NewChatRequest {
  const agentType = getAgentTypeFromQueryStringValue(getQueryParam('agent'));
  return agentType
    ? {
        id: null,
        type: ChatTypeByAgentType[agentType],
        agentType,
      }
    : {
        id: null,
        type: null,
      };
}

export const AIRoutes: RouteBundle = {
  domain: 'llm',
  routes: [
    {
      urlPattern: 'ai-connectors',
      handler: (): void => {
        if (
          !BenchlingConfig.MCP_SERVER_CONFIGURATION_ADMIN_PAGE ||
          !BenchlingConfig.LLM_ENABLE_AI_DEEP_RESEARCH
        ) {
          return;
        }
        DatadogUtil.startRUMView('ai_connectors');
        _editorBase(() => {
          SidepanelActions.expandSection(NavConstants.SECTIONS.MCPS);
        });
      },
      legacy: true,
    },
    {
      urlPattern: 'chats/new',
      handler: (): void => {
        DatadogUtil.startRUMView('chats_new');
        openNewChat(getChatTypeFromQueryParam(), {modal: getQueryParam('modal')});
        _editorBase(() => {
          SidepanelActions.expandSection(NavConstants.SECTIONS.AI);
        });
      },
    },
    {
      urlPattern: 'chats/:id',
      handler: (chatSessionId: string): void => {
        DatadogUtil.startRUMView('chats_existing');
        _editorBase(() => {
          openChat(chatSessionId);
        });
      },
    },
  ],
};
